module.exports = __webpack_public_path__ + "f833ff4e82fc1cbde191915913ca82e7.woff2";